import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeCargoConsultaProvimentosMembros: [],
    removeStatusConsultaProvimentosMembros: [],
    setMostraAplicarFiltroConsultaProvimentosMembros: [],
    limpaFiltroConsultaProvimentosMembros: [],
    aplicarFiltroConsultaProvimentosMembros: ['filtro'],
})

const INITIAL_STATE = {
    cargo: '',
    mostraAplicarFiltro: false,
    status: '',
}

const removeCargo = (state = INITIAL_STATE, action) => {
    return { ...state, cargo: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_CARGO_CONSULTA_PROVIMENTOS_MEMBROS]: removeCargo,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_PROVIMENTOS_MEMBROS]: setMostraAplicarFiltro,
    [Types.REMOVE_STATUS_CONSULTA_PROVIMENTOS_MEMBROS]: removeStatus,
    [Types.LIMPA_FILTRO_CONSULTA_PROVIMENTOS_MEMBROS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_PROVIMENTOS_MEMBROS]: aplicarFiltro,
})
